/* @sravni/react-design-system version 0.2.50 */
import { __assign, __rest } from 'tslib';
import * as React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { EASINGS } from './_utils.js';

var variants = {
    exit: function (props) { return (__assign(__assign({ opacity: 0 }, (props.reverse ? { scale: props.initialScale } : { transitionEnd: { scale: props.initialScale } })), { transition: {
            duration: 0.2,
            ease: EASINGS.easeOut,
        } })); },
    enter: {
        opacity: 1,
        scale: 1,
        transition: {
            duration: 0.25,
            ease: EASINGS.easeInOut,
        },
    },
};
var scaleFadeConfig = {
    variants: variants,
    initial: 'exit',
    animate: 'enter',
    exit: 'exit',
};
var ScaleFade = React.forwardRef(function (props, ref) {
    var _a = props.reverse, reverse = _a === void 0 ? true : _a, _b = props.initialScale, initialScale = _b === void 0 ? 0.95 : _b, unmountOnExit = props.unmountOnExit, visible = props.visible, rest = __rest(props, ["reverse", "initialScale", "unmountOnExit", "visible"]);
    var show = unmountOnExit ? visible && unmountOnExit : true;
    var custom = { initialScale: initialScale, reverse: reverse };
    var motionProps = React.useMemo(function () { return (__assign(__assign({}, scaleFadeConfig), { custom: custom, animate: visible || unmountOnExit ? 'enter' : 'exit' })); }, [visible, unmountOnExit, initialScale, reverse]);
    return (React.createElement(AnimatePresence, { custom: custom }, show && React.createElement(motion.div, __assign({ ref: ref }, motionProps, rest))));
});

export { ScaleFade, scaleFadeConfig };
//# sourceMappingURL=ScaleFade.js.map
